import { Store } from '../../types'

export const authTokenSelector = (store: Store) => store?.session?.authentication?.token
